import "./bootstrap"

import "@babel/polyfill";
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {store} from './store/index'
import VuexI28n from './plugins/vuex-i18n';
import VueSimpleSVG from 'vue-simple-svg'
import {Tab, Tabs} from 'vue-tabs-component';
import SvgFiller from 'vue-svg-filler';
import VShowSlide from 'v-show-slide'
import VueSignature from "vue-signature"
import {ValidationProvider, ValidationObserver} from 'vee-validate';

import Api from './plugins/api/index.js';
import Company from './plugins/company/index.js';

import './filters';

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import './mixins/validation'

import vueDebounce from 'vue-debounce'

Vue.use(Api);
Vue.use(Company);
Vue.use(VueSimpleSVG);
Vue.use(VShowSlide);
Vue.use(VueSignature)
Vue.use(VueSweetalert2);
Vue.use(vueDebounce)

Vue.component('svg-filler', SvgFiller);
Vue.component('tabs', Tabs);
Vue.component('tab', Tab);
Vue.component('validation-provider', ValidationProvider)
Vue.component('validation-observer', ValidationObserver)

Vue.config.productionTip = false;
Vue.config.devtools = true;

const app = new Vue({
    el: '#root',
    components: {App},
    router,
    store: store,
    VuexI28n,
    data: {
        apiUrl: window.config.apiUrl,
        showNav: false
    },
    methods: {
        openNav: function () {
            this.showNav = !this.showNav
        }
    },
    created() {
        if (!window.config.apiUrl.match(/\/$/)) {
            window.config.apiUrl += '/';
        }
        if (!this.$root.apiUrl.match(/\/$/)) {
            this.$root.apiUrl += '/';
        }

        Vue.i18n.set(this.$store.getters.getLanguage);
    }
});
